module.exports = __webpack_public_path__ + "static/media/ice-hockey-2.4cdd7324.svg";